export const CCPA_ANALYTICS = 'cresco_ccpa_analytics';
export const CCPA_MARKETING = 'cresco_ccpa_marketing';
export const CCPA_PERSONALIZATION = 'cresco_ccpa_personalization';
export const ACCESSIBILITY = 'cresco_accessibility';
